const WrappedButton = ({ children, onClick, style, className, href, variant, type = "button" }) => {
    if (variant === "button") {
        return <button className={className} onClick={onClick} type={type}>{children}</button>
    }
    return (

        <a onClick={onClick} style={style} className={className} href={href}>
            {children}
        </a>
    )
};

export default WrappedButton;